import { useEffect, useState } from 'react';
import {
  SelectBagByWarehouseModal,
  ISelectBagByWarehouseModalProps,
} from '@@/warehouses/components/select-bag-by-warehouse-modal';
import { IWarehouse } from '@@/warehouses/ts';
import { DiContainer } from '@@/di/di-container';
import { WarehousesService } from '@@/warehouses/services/warehouses.service';
import {
  warehouseMapper,
  warehouseWithBagsMapper,
} from '@@/warehouses/mappers/warehouse.mappers';

const warehousesService = DiContainer.get(WarehousesService);

export function SelectBagByWarehouseModalApi(
  props: ISelectBagByWarehouseModalApiProps,
) {
  const [warehouses, setWarehouses] = useState<IWarehouse[]>([]);
  const [loading, setLoading] = useState(false);

  const loadWarehouses = async () => {
    setLoading(true);
    const data = await warehousesService.find();
    setWarehouses(data.map(warehouseMapper));
    setLoading(false);
  };
  const onLoadBags: ISelectBagByWarehouseModalProps['onLoadBags'] = async (id) => {
    const data = await warehousesService.findOneById(id);
    return warehouseWithBagsMapper(data);
  };

  useEffect(() => void loadWarehouses(), []);

  return (
    <SelectBagByWarehouseModal
      warehouses={warehouses}
      loading={loading}
      onLoadBags={onLoadBags}
      {...props}
    />
  );
}

export interface ISelectBagByWarehouseModalApiProps
  extends Omit<
    ISelectBagByWarehouseModalProps,
    'warehouses' | 'loading' | 'onLoadBags'
  > {}
